export default __webpack_public_path__ + "74ca427d4f5120c923edd1b076afdc61.png";